import CloseIcon from "@mui/icons-material/Close";
import { Col, Button, Dropdown } from "react-bootstrap";
import Modal from "@mui/material/Modal";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Chip } from "@mui/material";
import Rating from "@mui/material/Rating";
import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import Toast from "react-bootstrap/Toast";
import React from "react";
import { AuthContext } from "../../../context/AuthContext";
import MONTHS from "../../../context/Months";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import GroupIcon from "@mui/icons-material/Group";
import MoreVert from "@mui/icons-material/MoreVert";
import { useParams } from "react-router-dom";
import FetchFingerprint from "../../../actions/FetchFingerprint";
import ENDPOINT from "../../../data/ENDPOINT";

const InterpersonalSkillsList = () => {
  const { user } = useContext(AuthContext);
  const params = useParams();
  const username = params.username;
  const [title, settitle] = useState(null);

  const [education, seteducation] = useState(null);
  const [level, setlevel] = useState(3);
  const SaveEducation = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("session", user.SessionId);
    formData.append("fp", FetchFingerprint());
    formData.append("title", title);
    formData.append("level", level);

    const res = await axios.post(
      `${ENDPOINT}interpersonal-skills-add.php`,
      formData,
      {
        headers: { "content-type": "multipart/form-data" },
      },
    );

    if (res) {
      // //  //  //console.log("added "+JSON.stringify(res));
      if (res.data.status === "success") {
        settoasttitle("Education added successfully");
        settoast(true);
        Fetch_education();
        setaddeducation(false);
        ClearData();
      } else {
      }
      //  //  //  //console.log(JSON.stringify(res))
    }
  };

  const [self, setself] = useState(false);
  const Fetch_education = async () => {
    const formdata = new FormData();
    formdata.append("session", user.SessionId);
    formdata.append("fp", FetchFingerprint());
    formdata.append("username", username);
    const res = await axios.post(
      `${ENDPOINT}user-interpersonal-skills.php`,
      formdata,
      {
        headers: { "content-type": "multipart/form-data" },
      },
    );
    if (res.data) {
      //    //  //  //console.log(JSON.stringify(res))
      if (res.data.status === "success") {
        if (res.data.data !== null || res.data.data !== "null") {
          seteducation(res.data.data);
          setself(res.data.self);
        }
      }
    }
  };

  const [editid, seteditid] = useState(null);
  const Edit = async ({ id, action, index }) => {
    seteditid(id);
    const formdata = new FormData();
    formdata.append("session", user.SessionId);
    formdata.append("fp", FetchFingerprint());
    formdata.append("id", id);
    if (action === "get") {
      settitle(education[index].title);
      setlevel(education[index].level);
      formdata.append("get", true);
    } else {
      formdata.append("title", title);
      formdata.append("level", level);
    }
    const res = await axios.post(
      `${ENDPOINT}interpersonal-skills-edit.php`,
      formdata,
      {
        headers: { "content-type": "multipart/form-data" },
      },
    );
    if (res) {
      //  //  //  //console.log("edit "+JSON.stringify(res))
      if (res.data.status === "success") {
        if (action === "get") {
          setedit(true);
        } else {
          setedit(false);
          Fetch_education();
        }
        if (res.data.data === null) {
          settoasttitle("Edit successful");
          settoast(true);
          setedit(false);
          ClearData();
          Fetch_education();
        } else {
          if (action === "get") {
            setedit(true);
          }
        }
      }
    }
  };

  useEffect(() => {
    Fetch_education();
  }, []);
  const Delete = async ({ education_id }) => {
    const data = new FormData();
    data.append("id", education_id);
    data.append("session", user.SessionId);
    data.append("fp", FetchFingerprint());
    const res = await axios.post(
      `${ENDPOINT}interpersonal-skills-delete.php`,
      data,
      {
        headers: { "content-type": "multipart/form-data" },
      },
    );
    if (res) {
      // //  //  //console.log(JSON.stringify(res))
      if (res.data.status === "success") {
        settoasttitle("Deleted successfully");
        settoast(true);

        Fetch_education();
      }
    }
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",

    bgcolor: "background.paper",

    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  const [addeducation, setaddeducation] = useState(false);
  const defaultProps = {
    options: MONTHS,
    getOptionLabel: (option) => option.name,
  };

  const [edit, setedit] = useState(false);

  const [toast, settoast] = useState(false);

  const [toasttitle, settoasttitle] = useState(null);
  const [toastmessage, settoastmessage] = useState(null);

  const ClearData = () => {
    settitle(null);
  };
  return (
    <>
      <div className="toast-container">
        <Toast
          className="bg-warning"
          onClose={() => settoast(false)}
          show={toast}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">{toasttitle}</strong>
          </Toast.Header>
          <Toast.Body>{toastmessage}</Toast.Body>
        </Toast>
      </div>

      <Modal open={edit} onClose={() => setedit(false)}>
        <Box className="col-lg-5 col-md-5 col-sm-6 col-11" sx={style}>
          <div className="w-100">
            <div className="flex align-items-center space-between">
              <h4>Add Skill</h4>
              <CloseIcon
                type="button"
                onClick={() => {
                  setedit(false);
                }}
              />
            </div>
            <hr />
            <form
              method="post"
              onSubmit={(e) => {
                e.preventDefault();
                Edit({ id: editid, action: "edit" });
              }}
            >
              <label className="mt-1 w-100 me-3">Skill Title</label>
              <input
                required
                minLength={3}
                maxLength={30}
                className="  form-control me-3"
                type="text"
                value={title}
                onChange={(e) => {
                  settitle(e.target.value);
                }}
                name="title"
              ></input>
              <br />
              <label className="mt-1 me-3">Level</label>

              <div className="flex">
                <Rating
                  name="simple-controlled"
                  value={level}
                  onChange={(event, newValue) => {
                    setlevel(newValue);
                  }}
                />

                {level === 1
                  ? "Beginner"
                  : level === 2
                    ? "Intermediate"
                    : level === 3
                      ? "Average"
                      : level === 4
                        ? "Better"
                        : "Best"}
              </div>

              <div className="text-center mt-4 mb-4">
                <button
                  type="submit"
                  className="btn btn-warning btn-lg px-5 py-2 fw-bold text-white"
                  style={{ minWidth: "220px" }}
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </Box>
      </Modal>

      <Modal open={addeducation} onClose={() => setaddeducation(false)}>
        <Box className="col-lg-5" sx={style}>
          <div className="w-100">
            <div className="flex align-items-center space-between">
              <h4>Add Skill</h4>
              <CloseIcon
                type="button"
                onClick={() => {
                  setaddeducation(false);
                }}
              />
            </div>
            <hr />
            <form method="post" onSubmit={SaveEducation}>
              <label className="mt-1 w-100 me-3">Skill Title</label>
              <input
                required
                minLength={3}
                maxLength={30}
                className="  form-control me-3"
                type="text"
                value={title}
                onChange={(e) => {
                  settitle(e.target.value);
                }}
                name="title"
              ></input>
              <br />

              <div className="flex">
                <Rating
                  name="simple-controlled"
                  value={level}
                  onChange={(event, newValue) => {
                    setlevel(newValue);
                  }}
                />
                {level === 1
                  ? "Beginner"
                  : level === 2
                    ? "Intermediate"
                    : level === 3
                      ? "Average"
                      : level === 4
                        ? "Better"
                        : "Best"}
              </div>

              <Button variant="btn btn-warning  w-100 mt-5" type="submit">
                Save Changes
              </Button>
            </form>
          </div>
        </Box>
      </Modal>

      {education ? (
        <>
          <div className=" border br-5 sm-br-none sm-shadow-none p-3">
            <div className="flex space-between align-items-center interpersonal-skills-header">
              <h4
                style={{ color: "rgb(234 88 12)", fontWeight: 700 }}
                className="mb-3 pt-2"
              >
                Interpersonal Skills
              </h4>
              {self ? (
                <>
                  <button
                    style={{ background: "rgb(234 88 12) ", color: "#ffffff" }}
                    type="button"
                    onClick={() => setaddeducation(true)}
                    className="btn add-skill-btn fw-bold shadow-sm"
                  >
                    ADD
                  </button>
                </>
              ) : null}
            </div>

            <Col lg={12} md={12} sm={12} xs={12} className=" rounded p-3 ">
              {education && education.length > 0 ? (
                <>
                  {education.map((edu, index) => (
                    <div key={edu.id} className="mt-3 mb-3">
                      <div
                        style={{
                          border: "1px solid #f5e3d6",
                          borderRadius: "12px",
                          padding: "16px",
                          backgroundColor: "#fff",
                        }}
                      >
                        <div
                          className="flex space-between align-items-start"
                          style={{ flexWrap: "wrap", gap: "12px" }}
                        >
                          <div
                            className="flex"
                            style={{ flex: 1, minWidth: "200px" }}
                          >
                            <div
                              className="skill-icon"
                              style={{
                                width: 56,
                                height: 56,
                                borderRadius: "50%",
                                backgroundColor: "rgba(255,165,0,0.18)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginRight: 14,
                                flexShrink: 0,
                              }}
                            >
                              <GroupIcon
                                style={{ color: "orange", fontSize: 28 }}
                              />
                            </div>
                            <div style={{ minWidth: 0, flex: 1 }}>
                              <h5
                                style={{
                                  margin: "0 0 8px 0",
                                  fontWeight: 700,
                                  color: "#292929",
                                  fontSize: "18px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {edu.title}
                              </h5>
                              <div style={{ marginBottom: "8px" }}>
                                <Rating
                                  style={{
                                    margin: "6px 0 4px",
                                    color: "rgb(234 88 12)",
                                  }}
                                  name={`rating-${edu.id}`}
                                  value={edu.level}
                                  size="small"
                                  readOnly
                                />
                              </div>
                              <p
                                style={{
                                  margin: "0",
                                  fontSize: "14px",
                                  color: "#585f65",
                                }}
                              >
                                {edu.level === 1
                                  ? "Beginner"
                                  : edu.level === 2
                                    ? "Intermediate"
                                    : edu.level === 3
                                      ? "Average"
                                      : edu.level === 4
                                        ? "Better"
                                        : "Best"}
                              </p>
                            </div>
                          </div>

                          <div
                            className="flex flex-column align-items-end skill-card-actions"
                            style={{
                              marginLeft: "12px",
                              textAlign: "center",
                              minWidth: "80px",
                            }}
                          >
                            {self ? (
                              <>
                                <div
                                  style={{
                                    marginBottom: "12px",
                                    display: "flex",
                                    gap: "12px",
                                    flexWrap: "wrap",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <button
                                    type="button"
                                    style={{
                                      width: "44px",
                                      height: "44px",
                                      border: "2px solid #ff9800",
                                      borderRadius: "8px",
                                      backgroundColor: "#fff",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      transition: "all 0.2s",
                                    }}
                                    onClick={() =>
                                      Edit({
                                        id: edu.id,
                                        action: "get",
                                        index: index,
                                      })
                                    }
                                    aria-label="edit"
                                  >
                                    <EditIcon
                                      style={{
                                        fontSize: "20px",
                                        color: "#ff9800",
                                      }}
                                    />
                                  </button>
                                  <button
                                    type="button"
                                    style={{
                                      width: "44px",
                                      height: "44px",
                                      border: "2px solid #dc3545",
                                      borderRadius: "8px",
                                      backgroundColor: "#fff",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      transition: "all 0.2s",
                                    }}
                                    onClick={() =>
                                      Delete({ education_id: edu.id })
                                    }
                                    aria-label="delete"
                                  >
                                    <DeleteIcon
                                      style={{
                                        fontSize: "20px",
                                        color: "#dc3545",
                                      }}
                                    />
                                  </button>
                                </div>
                              </>
                            ) : null}
                            {/* <small
                              style={{ color: "#9ca3af", fontSize: "12px" }}
                            >
                              Best
                            </small> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  {self ? (
                    <>
                      <div
                        onClick={() => setaddeducation(true)}
                        type="button"
                        className="flex text-primary align-items-center"
                      >
                        <AddIcon className="mr-2" />
                        <h6 className="mb-0 ">Add Interpersonal Skill</h6>
                      </div>
                    </>
                  ) : null}
                </>
              )}
            </Col>
          </div>
        </>
      ) : (
        <>
          <div className="border  br-5 sm-br-none  text-center mt-5 p-3">
            {education ? (
              <>
                <div className="flex space-between align-items-center">
                  <h4
                    className="mb-3 pt-2"
                    style={{ color: "rgb(234 88 12)", fontWeight: 700 }}
                  >
                    Interpersonal Skills
                  </h4>
                  {self ? (
                    <>
                      <button
                        style={{
                          background: "rgb(234 88 12) ",
                          color: "#ffffff",
                        }}
                        type="button"
                        onClick={() => setaddeducation(true)}
                        className="btn add-skill-btn fw-bold shadow-sm"
                      >
                        ADD
                      </button>
                    </>
                  ) : null}
                </div>
              </>
            ) : null}
            {self ? (
              <>
                <div className="container empty-profile-section ">
                  <h4
                    onClick={() => setaddeducation(true)}
                    className="btn  rounded-pill btn-outline-secondary"
                  >
                    Add Interpersonal Skill
                  </h4>
                </div>
              </>
            ) : (
              <>
                <div className="text-center">
                  <h5 className="text-secondary">
                    No Interpersonal Skills Added
                  </h5>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};
export default InterpersonalSkillsList;